var _path, _path2, _path3, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCertifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,40.75a.74671.74671,0,0,0,.53027-.21973l8-8-1.06054-1.06054L24,38.93945l-3.46973-3.46972-1.06054,1.06054,4,4A.74671.74671,0,0,0,24,40.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70,19.25H10a.7502.7502,0,0,0-.75.75V60a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V20A.7502.7502,0,0,0,70,19.25Zm-.75,40H10.75V20.75h58.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25,44.35516V54a.75024.75024,0,0,0,1.166.624L26,50.90137,31.584,54.624A.75024.75024,0,0,0,32.75,54V44.35516a10.75,10.75,0,1,0-13.5,0Zm12,8.24347L26.416,49.376a.74991.74991,0,0,0-.832,0L20.75,52.59863v-7.227a10.68707,10.68707,0,0,0,10.5,0ZM26,26.75A9.25,9.25,0,1,1,16.75,36,9.26032,9.26032,0,0,1,26,26.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 31.25,
    width: 22,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 39.25,
    width: 22,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 47.25,
    width: 14,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertifications);
export default __webpack_public_path__ + "static/media/icon_certifications.321153681cb25a43d980041fbb946208.svg";
export { ForwardRef as ReactComponent };